var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraduate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_260_62)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.22252 13.345C2.26669 13.3516 6.25502 14.025 9.16669 14.1466V18.355C6.25585 18.4766 2.26669 19.1508 2.22252 19.1575C1.84169 19.2158 1.46669 19.035 1.31585 18.7241C1.29669 18.6833 0.83252 17.7133 0.83252 16.2516C0.83252 14.79 1.29585 13.82 1.31585 13.7791C1.46752 13.4683 1.84169 13.2858 2.22252 13.345ZM15.8334 9.23415C14.11 9.97665 12.2909 10.5066 10.3842 10.8033C10.125 10.8433 9.87752 10.8433 9.62085 10.8033C7.71085 10.5066 5.89085 9.97581 4.16669 9.23331V11.955C5.83835 12.195 8.29335 12.4991 10 12.4991C11.7067 12.4991 14.1767 12.1933 15.8334 11.9558V9.23415ZM19.1667 4.99998C19.1567 4.74081 19.025 4.46748 18.8117 4.31748C16.2175 2.52331 13.3075 1.33165 10.1284 0.843313C10.0425 0.82998 9.95752 0.82998 9.87169 0.843313C6.69585 1.33665 3.77419 2.50581 1.18835 4.31748C0.975019 4.46748 0.843353 4.74081 0.833353 4.99998C0.843353 5.25915 0.975019 5.53248 1.18835 5.68248C3.77419 7.49415 6.69585 8.66331 9.87169 9.15665C9.95752 9.16998 10.0425 9.16998 10.1284 9.15665C12.4559 8.79498 14.645 8.06665 16.6667 6.99248V9.58331C16.6667 10.2741 17.2259 10.8333 17.9167 10.8333C18.6075 10.8333 19.1667 10.2741 19.1667 9.58331C19.1692 9.37915 19.1634 5.18165 19.1667 4.99998ZM17.7775 13.345C17.7334 13.3516 13.745 14.025 10.8334 14.1466V18.355C13.7442 18.4766 17.7334 19.1508 17.7775 19.1575C18.14 19.2158 18.5359 19.0383 18.6842 18.7241C18.7034 18.6833 19.1675 17.7133 19.1675 16.2516C19.1675 14.79 18.7042 13.82 18.6842 13.7791C18.5325 13.4683 18.1542 13.285 17.7775 13.345Z",
    fill: "url(#paint0_linear_260_62)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_260_62",
    x1: 10,
    y1: 0.833313,
    x2: 10,
    y2: 19.1685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91C04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009EDB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_260_62"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduate);
export default __webpack_public_path__ + "static/media/graduate.411b2b4a3405c7e5a92ddab5e00971f5.svg";
export { ForwardRef as ReactComponent };